<template>
	<section>

		<el-dialog title="提示" :visible.sync="visible" width="800px" :before-close="close"
			:show-close="false" lock-scroll :close-on-click-modal="false">
			<div v-show="set_type==0">
				<el-input clearable type="textarea" :autosize="{ minRows:5}" v-model="text" placeholder="请输入内容..."
					style="margin-bottom:20px;" show-word-limit :maxlength="maxlength"></el-input>
				<div slot="footer" class="dialog-footer" style="text-align:right">
					<el-button @click="close" :loading="loading">取 消</el-button>
					<el-button type="primary" :loading="loading" @click="submit()">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<image-editor ref="imageEditorRef"  @close="set_type=null" @success="cutDown" >
			<el-button type='primary' @click="toSelectPhoto">选择图片</el-button>
		</image-editor>

		<select-photo ref="selectPhotoRef" @getCheckPhoto="getCheckPhoto" @commitDeirect="commitDeirect"
			:is_show_upload="formData&&formData.type==8?true:false" @toCommit="toCommit"></select-photo>
	</section>
</template>
<script>
	import ImgCutter from "@/components/tools/ImgCutter";
	import { mapState } from "vuex";
	import { upload } from "@/api/book";
	import selectPhoto from "@/components/album/selectPhoto";
	import ImageEditor from '../image-editor.vue';
	export default {
		data() {
			return {
				set_type: null, //空：编辑文本，1上传图片
				text: "",
				maxlength: 80,

				option: {
					id: 0,
					targetWidth: 300,
					targetHeight: 300,
					translate3dInfo: {
						rotation: 0,
						scale: 1,
						offset_x: 0,
						offset_y: 0
					}
				},
				visible: false,
				toImg: {
					dataURL: "",
					file: null,
					describe: ""
				},

				formData: {
					is_all: false
				},
				is_all: false,

				loading: false,
				cur_rate: "1:1",

				is_add_to_album: false //是否需要上传到班级相册中
			};
		},

		components: { ImgCutter, selectPhoto, ImageEditor },
		computed: {
			...mapState("book", ["cur_page", "book", "id"])
		},

		methods: {
			openInputFile() {
				this.is_add_to_album = true;
			},
		
			toSelectPhoto(isFlag) {
				this.is_add_to_album = false;
				let student_id =
					this.formData && this.formData.student_info
						? this.formData.student_info.user_id
						: null;
				let class_id =
					this.formData && this.formData.student_info
						? this.formData.student_info.class_id
						: null;
				let tag_ids =
					this.formData && this.formData.config
						? this.formData.config.datasource
						: null;
				let is_flag = isFlag || (this.formData && this.formData.type == 8 ? 1 : 0);
				this.$refs.selectPhotoRef.open(
					class_id,
					student_id,
					tag_ids,
					is_flag
				);
			},
			toCommit(data) {
				let param1 = new FormData();
				param1.append("file[]", data.file);
				const load_in = this.$loading({
					lock: true,
					text: "正在上传",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.6)"
				});
				upload.uploadPhoto(param1).then(res => {
					setTimeout(() => {
						load_in.close();
					}, 500);
					if (res.data && res.data.length > 0) {
						let a = {
							describe: data.digest,
							path: res.data[0].path_full
						};

						if (
							this.formData &&
							this.formData.data &&
							this.formData.data.length > 0
						) {
							if (a.describe == undefined || a.describe == "") {
								a.describe = this.formData.data[this.formData.photo_index]
									? this.formData.data[this.formData.photo_index].describe : "宝宝相片";
							}
							this.formData.data.splice(this.formData.photo_index, 1, a);
						} else {
							this.formData.data = [a];
						}

						let param1 = {
							student_id: this.formData.student_info
								? this.formData.student_info.user_id
								: null,
							tag_ids: this.formData.config
								? this.formData.config.datasource
								: [],
							photos: [{ id: res.data[0].id, digest: "" }]
						};
						upload.addPhoto(param1); //把相片上传到班级相册中
						this.toSave();
					}
				});
			},

			commitDeirect(item) {
				console.log("commitDeirect==>", item)
				let a = { describe: item.digest, path: item.path };

				if (
					this.formData &&
					this.formData.data &&
					this.formData.data.length > 0
				) {
					if (a.describe == undefined || a.describe == "") {
						a.describe = this.formData.data[this.formData.photo_index]
							? this.formData.data[this.formData.photo_index].describe
							: "宝宝相片";
					}
					this.formData.data.splice(this.formData.photo_index, 1, a);
				} else {
					this.formData.data = [a];
				}
				this.toSave();
			},
			close() {
				if (this.$refs.imgCutterModal) {
					this.$nextTick(_ => {
						this.$refs.imgCutterModal.clearAll();
					});
				}

				this.visible = false;
				this.toImg = { dataURL: null, file: null, describe: "" };
				this.text = "";
				this.formData = null;
				this.loading = false;
				this.set_type = null;
				this.is_add_to_album = false;
			},

			// 0  修改园长寄语（只有文本）
			// 1  修改相片（只有相片）
			// 2.更换页面的背景
			// 3.修改老师简介的摘要
			// 4  相片的描述
			// 5 修改家长寄语中的图片（包括家长寄语）
			// 6 修改家长寄语中的文本（包括家长寄语图片）
			openEditVisible(data) {
			
				this.formData = data;
				this.is_all = data.is_all
				if (data.type == 2) {
					this.toSave();
					return;
				}

				this.visible = data.type != 7 && data.type != 8 && data.type!=1 ? true : false;
				this.set_type =
					data.type == 7 || data.type == 8
						? null
						: data.type == 1 || data.type == 5
							? 1
							: 0;
				
				switch (this.formData.type) {
					case 8: //毕业照选择图片（无需裁剪图片）
						this.toSelectPhoto();
						break;
					case 5:
					case 1:
						this.toImg.dataURL = data.data[data.photo_index] ? data.data[data.photo_index].path : "";
						console.log("this.formData=",this.formData)
						this.$nextTick(_ => {
							if(data.upload){
								this.toSelectPhoto(1)
							}else if(data.edit){
								this.$refs.imageEditorRef.open(this.toImg.dataURL,this.formData.imgRate)
							}						
						})
						break;
					case 0: // 修改园长寄语或家长寄语（不包括图片）
						this.text = data.data && data.data.data ? data.data.data.content : "";
						break;
					case 3: // 修改老师简介
						const index = data.index || 0
						this.text = data.data[index].brief;
						this.maxlength = 120
						break;
					case 4: // 修改相片文本
						this.text = data.data[data.index].describe;
						break;
					case 6: // 修改寄语中的文本（包括图片）
						this.text =
							data.data[data.index] &&
								data.data[data.index].data &&
								data.data[data.index].data.content
								? data.data[data.index].data.content
								: "";
						break;
					case 7: //直接提交
						this.toSave();
						break;
				}
			},

			getCheckPhoto(data) {
				this.set_type = 1;
				this.toImg.dataURL = data.path;
				this.toImg.describe = data.digest;
				this.$nextTick(_ => {
					this.$refs.imageEditorRef.replace(this.toImg.dataURL)
				});
			},
			submit() {
				if (!this.formData) {
					return;
				}

				switch (this.formData.type) {
					case 5:
					case 1:
						let param1 = new FormData();
						param1.append("file[]", this.toImg.file);
						upload.uploadPhoto(param1).then(res => {
							if (res.data && res.data.length > 0) {
								let a = {
									describe: this.toImg.describe,
									path: res.data[0].path_full,
									id: res.data[0].id
								};
								if (this.formData.data &&
									this.formData.data.length > 0) {
									if (a.describe == undefined || a.describe == "") {
										a.describe = this.formData.data[
											this.formData.photo_index
										] ? this.formData.data[this.formData.photo_index].describe : "宝宝相片";
									}
									this.formData.data.splice(this.formData.photo_index, 1, a);
									let student_id = this.formData.student_info ? this.formData.student_info.user_id : null;
									if (this.is_add_to_album && student_id) {
										let param1 = {
											student_id: student_id,
											tag_ids: this.formData.config ? this.formData.config.datasource : [],
											photos: [
												{ id: res.data[0].id, digest: "" }
											]
										};
										upload.addPhoto(param1).then(orr => { }); //把相片上传到班级相册中
									}
								} else {
									this.formData.data = [a];
								}
								this.toSave();
							}
						});
						break;
					case 0: // 修改园长寄语或家长寄语（不包括图片）
						this.formData.data.data.content = this.text;
						this.toSave();
						break;
					case 3: // 修改老师简介
						if (this.formData.index) {
							this.formData.data[this.formData.index].brief = this.text;
						} else {
							this.formData.data.forEach(e => e.brief = this.text)
						}

						this.toSave();
						break;
					case 4: // 修改相片文本
						this.formData.data[
							this.formData.index
						].describe = this.text;

						this.toSave();
						break;
					case 6: // 修改寄语中的文本（包括图片）
						if (
							this.formData.data[this.formData.index] &&
							this.formData.data[this.formData.index].data
						) {
							this.formData.data[
								this.formData.index
							].data.content = this.text;
						} else {
							this.formData.data[this.formData.index] = {
								data: { content: this.text }
							};
						}
						this.toSave();
						break;
				}
			},

			toSave() {
				this.loading = true;
				this.formData.is_all = this.is_all
				this.$store.commit("book/getParam", this.formData);
				console.log("====toSave====>", this.formData)
				let index1 = this.formData.page_index || 0;
				this.$store.dispatch("book/saveItem").then(res => {
					this.loading = false;
					if (res.code == 0) {
						this.close();
						this.$message({ message: "保存成功！", type: "success" });
						this.$parent.reGeg(index1);
					}
				});
			},

			cutDown(e) {
				this.toImg.dataURL = e.dataURL;
				this.toImg.file = e.file;
				if (!this.toImg.file) {
					this.$toast("未选择图片");
					return;
				}
				this.submit();
			}
		},

		mounted() { }
	};
</script>
<style scoped lang="scss">
	.wrapper {
		display: flex;
		flex-direction: column;
		background: #ffffff;
		width: 60%;
		justify-content: center;
		margin: 0 auto;
		height: 80%;
		padding-bottom: 20px;
		position: relative;
		margin-top: auto;
		margin-bottom: auto;
		margin: 0 auto;
		z-index: 8000;
	}

	.wrapper /deep/ .i-dialog-footer {
		display: flex;
		justify-content: space-between;
		.fr {
			margin-left: auto;
			display: flex;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/book/editBook.vue